import { QuestionCircleOutlined, SortDescendingOutlined, SortAscendingOutlined, } from '@ant-design/icons';
import React, { Fragment, useState, useEffect } from 'react';
import { useZoneList, useDeleteZone, useStatusSite } from "hooks/configuration/zone/zone";
import { PAGES, ACTIONS, usePermissions } from 'hooks/permissions/permissions';
import StatusBadge from 'components/statusBadge';
import { Row, Col, Button, Input, Pagination, message, Popconfirm } from 'antd';
import { statusColor, PAGE_SIZE_OPTIONS, DEFAULT_PAGE_SIZE } from "helpers/commonFunctions";
import { Link } from 'react-router-dom';
import Image from 'helpers/Image';
import "../style.css";
import TableStateRow from "components/tableState";


const Zone = () => {
    const { can } = usePermissions();
    const canAdd = can(PAGES.SITE, ACTIONS.ADD);
    const canEdit = can(PAGES.SITE, ACTIONS.EDIT);
    const canDelete = can(PAGES.SITE, ACTIONS.DELETE);
    const showActions = canEdit || canDelete;
    const columnCount = showActions ? 4 : 3;

    const [page, setPage] = useState(DEFAULT_PAGE_SIZE);
    const [listData, setListData] = useState(null);
    const [pageNumber, setPageNumber] = useState(0);
    const [searchKey, setSearchKey] = useState("");
    const [sortField, setSortField] = useState("");
    const [sortMethod, setSortMethod] = useState("desc");
     const [defaultCall, setDefaultCall] = useState(false);

    const [initValues, setInitValues] = useState({
        "sortField": "",
        "sortMethod": "desc",
        "pageNumber": pageNumber,
        "pageSize": page,
        "searchKey": searchKey
    });

    const [sorting, setSorting] = useState({
        "s.site_name": null,
        "s.active": null,
    });

    const { mutate: getZoneList, data: zoneListData, isLoading: Loading } = useZoneList();
    const { mutate: deleteZone, isLoading: deleteLoading } = useDeleteZone();
    const { mutate: statusChange } = useStatusSite();

    const deleteId = (id) => {
        deleteZone(id, {
            onSuccess: (item) => {
                if (item.statusCode === 200) {
                    message.success(item?.message || item?.data);
                    onFetchZoneList(initValues);
                }
                else {
                    message.error(item?.message || item?.data);
                }
            },
        });
    }

    const onFetchZoneList = (values) => {
        getZoneList(values, {
            onSuccess: (item) => {
                setListData(item?.data?.content);
            }
        })
    }

    const onChange = (page) => {
        initValues.pageNumber = page - 1;
        setInitValues(initValues);
        setPageNumber(page - 1);
    }

    const onSortChange = async (column) => {
        initValues.pageNumber = 0;
        initValues.sortField = column;
        initValues.sortMethod = sorting[column] === 'asc' ? 'desc' : 'asc';
        setPageNumber(0);
        const newSorting = {
            ...sorting,
            [column]: sorting[column] === 'asc' ? 'desc' : 'asc',
        };
        setSorting(newSorting);
        setInitValues(initValues);
        setSortField(column);
        setSortMethod(newSorting[column]);
        setListData([]);
    };

    const onShowSizeChange = (current, pageSize) => {
        setPage(initValues.pageSize = pageSize)
    }

    const handleConfirmActive = (id) => {
        statusChange(id, {
            onSuccess: (item) => {
                if (item.statusCode === 200) {
                    message.success(item.message);
                    onFetchZoneList(initValues);
                }
                else {
                    message.error(item?.message);
                }
            },
        });
    }

    const onSearchHandler = (e) => {
        initValues.searchKey = e.target.value;
        let data = { ...initValues };
        data.searchKey = e.target.value;
        data.pageNumber = e.target.value !== "" ? 0 : initValues.pageNumber;
        e.target.value !== "" ? data.pageNumber = 0 : data.pageNumber = pageNumber;
        setInitValues(data);
        setSearchKey(e.target.value);
    }
     useEffect(() => {
            setDefaultCall(true);
        }, [])

    useEffect(() => {
        if (defaultCall) {
        onFetchZoneList(initValues);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultCall,pageNumber, searchKey, page, sortField, sortMethod]);

    return (
        <Fragment>
            <div className="common-head">
                <div className="title">
                    <h1>Sites</h1>
                    <p>Sites and the gate locations within them</p>
                </div>
                <div className="txt-right single-line">
                    <Input placeholder='Search' onChange={onSearchHandler} prefix={<Image className="search-img" name={"search.svg"} />} allowClear />
                    {!canAdd ? null : <Link to="/configuration/zone/create">
                        <Button><Image name="plus.png" /> New Site</Button>
                    </Link>}
                </div>
            </div>
            <div className="common-table">
                <table>
                    <thead>
                        <tr>
                            <th>Site Name {sorting["s.site_name"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("s.site_name")} /> : <SortDescendingOutlined onClick={() => onSortChange("s.site_name")} />}</th>
                            <th>Location</th>
                            <th>Status {sorting["s.active"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("s.active")} /> : <SortDescendingOutlined onClick={() => onSortChange("s.active")} />}</th>
                            {showActions ? <th>Action</th> : null}
                        </tr>
                    </thead>
                    <tbody>
                        {Loading ? (
                            <TableStateRow colSpan={columnCount} loading />
                        ) : listData == null || listData === undefined || listData?.length === 0 ? (
                            <TableStateRow colSpan={columnCount}>No sites found</TableStateRow>
                        ) : listData.map((item, a) => (
                                <tr key={a}>
                                    <td>{item?.siteName}</td>
                                    <td style={{ position: "relative" }}>
                                        <div
                                            style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                maxWidth: "220px",
                                                cursor: "pointer",
                                            }}
                                            title={item?.locationResDtoList?.map(loc => loc.locationName).join(", ")}
                                        >
                                            {item?.locationResDtoList?.map(loc => loc.locationName).join(", ")}
                                        </div>
                                    </td>
                                    <td>
                                        {canEdit ? <Popconfirm title={`Are you sure you want to ${item?.active === true ? "inactivate" : "activate"} this ${item?.siteName}?`}
                                            onConfirm={() => handleConfirmActive(item.siteId)}
                                            icon={
                                                <QuestionCircleOutlined />
                                            }
                                            okText="Yes"
                                            cancelText="No">
                                            <button className={statusColor(item.active)}>
                                                {item?.active ? "Active" : "InActive"}
                                            </button>
                                        </Popconfirm> : <StatusBadge active={item?.active} />}
                                    </td>
                                    {showActions ? <td>
                                        {!canEdit ? null : <Link to={`/configuration/zone/${item.zoneId}`} state={item}>
                                            <Image name="edit.png" />
                                        </Link>}
                                        {!canDelete ? null : <Popconfirm
                                            Loading={deleteLoading}
                                            title={`Are you sure to delete ${item?.siteName}?`}
                                            onConfirm={() => deleteId(item?.siteId)}
                                            icon={
                                                <QuestionCircleOutlined />
                                            }
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Image name="delete.png" />
                                        </Popconfirm>}
                                    </td> : null}
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            <Row className="table-pagination">
                <Col md={12}>
                    <h5>Showing {pageNumber === 0 ? 1 : (zoneListData?.data?.pageable?.offset + 1 || 0)} to {page === 0 ? (zoneListData?.data?.pageable?.offset + listData?.length || 0) : (zoneListData?.data?.pageable?.offset + zoneListData?.data?.numberOfElements || 0)} of {zoneListData?.data?.totalElements} entries</h5>
                </Col>
                <Col md={12} className="txt-right">
                    {zoneListData?.data?.content?.length === 0 ? null : <Pagination pageSize={page} showSizeChanger pageSizeOptions={PAGE_SIZE_OPTIONS} onChange={onChange} current={pageNumber + 1} onShowSizeChange={onShowSizeChange} total={zoneListData?.data?.totalElements} />}
                </Col>
            </Row>
        </Fragment >
    )
}

export default Zone;
